import React, { useEffect, useState } from 'react';
import { fetchData } from '../../services/stacks';
import { clientNetwork, exhibitIndexFileName } from '../../lib/constants';
import MarkdownIt from 'markdown-it';
import ExhibitViewOnly from './ExhibitViewOnly';
import AdvisoryModal from '../modal/AdvisoryModal';
import { authenticatedUserAddress, getUserData, isUserSignedIn } from '../../services/auth';
import axios from 'axios';
import { Alert, Snackbar } from '@mui/material';

const appOrigin = window.location.origin;

const Exhibits = ({
    setShowUserContractDeployModal,
    setShowWoopsModal,
    setOpenConfirmModal,
    userContractStatus,
    storageUrl,
    profileAddress,

    txId,
    setTxId,
    tx_Id,
    setTx_Id
}) => {
    const [exhibits, setExhibits] = useState([]);
    const [showAdvisoryModal, setShowAdvisoryModal] = useState(false);
    const [openSnackBar, setOpenSnackBar] = useState(false);

    const [errorMsg, setErrorMsg] = useState({ msg: '', reason: '' });

    const originDifference = storageUrl === getUserData()?.profile?.apps[appOrigin] || false;


    useEffect(() => {
        async function init() {
            // try {
            let exhibitArray, authenticatedUser = isUserSignedIn() ? authenticatedUserAddress({ network: clientNetwork }) : '';
            const exhibitIndexs = (await axios.get(storageUrl + exhibitIndexFileName)).data;
            exhibitArray = Object.entries(exhibitIndexs).map(([title, details]) => ({ title, ...details }));
            exhibitArray = await Promise.all(exhibitArray.map(async (res) => {
                let file;
                if (profileAddress === authenticatedUser) {
                    console.log(getUserData().profile.apps[appOrigin], { exhibitIndexs, storageUrl });

                    if (originDifference) {
                        file = await fetchData(`${res.fileName}?t=${new Date().getTime()}`, { decrypt: res.status === 'Draft' ? true : false });
                        file = file.success ? file.result : file.error.message;
                    } else {
                        file = res.status === "Published" ? (await axios.get(`${storageUrl + res.fileName}?t=${new Date().getTime()}`)).data : { title: res.title, fileName: res.fileName, lastUpdated: res.lastUpdated, status: res.status, content: `Oops! 🔒 This exhibit was created on a different origin, as such its locked to this origin!` };
                    }
                } else {
                    file = res.status === "Published" ? (await axios.get(`${storageUrl + res.fileName}?t=${new Date().getTime()}`)).data : { title: res.title, fileName: res.fileName, lastUpdated: res.lastUpdated, status: res.status, content: `Oops! 🔒 The author hasn't unlocked this Exhibit yet. Stay tuned for the reveal!` };
                    console.log({ theFile: file, res });
                }
                console.log({ res, file });
                return { ...file, status: res.status };
            }))
            setExhibits(exhibitArray);
            // } catch (error) { console.log({ error }); }
        }
        init();
    }, [])

    return (
        <>

            <div className="family-of-chimes-container">
                <div className="chime-bumper" />
                {exhibits.map(({ content, fileName, lastUpdated, title, status }, i) => {
                    console.log({ content, fileName, lastUpdated, title, status })
                    return (
                        <ExhibitViewOnly fileName={fileName} title={title} content={content} status={status} created={lastUpdated} key={i} profileAddress={profileAddress}
                            setShowWoopsModal={setShowWoopsModal}
                            setShowUserContractDeployModal={setShowUserContractDeployModal}
                            setOpenConfirmModal={setOpenConfirmModal}
                            userContractStatus={userContractStatus}
                            storageUrl={storageUrl}
                            setShowAdvisoryModal={setShowAdvisoryModal}
                            setOpenSnackBar={setOpenSnackBar}
                            setErrorMsg={setErrorMsg}
                            originDifference={originDifference}
                        />
                    )
                })}
            </div>

            {showAdvisoryModal && (<AdvisoryModal show={showAdvisoryModal} close={() => setShowAdvisoryModal(false)} />)}

            {openSnackBar && <Snackbar open={openSnackBar} autoHideDuration={3000} onClose={() => setOpenSnackBar(false)}      >
                <Alert onClose={() => setOpenSnackBar(false)} severity={errorMsg.reason} sx={{ width: '100%' }}        >
                    {errorMsg.msg}
                </Alert>
            </Snackbar>}
        </>
    );
};

export default Exhibits;